import {
  addActionBarDropdownMenuItem,
  ModalService,
} from '@vendure/admin-ui/core';

import { MarketingPreferencesDownloadDialogComponent } from './marketing-preferences-download-dialog.component';

export default [
  addActionBarDropdownMenuItem({
    id: 'export-marketing-preferences',
    locationId: 'customer-list',
    label: 'Export marketing preferences CSV',
    icon: 'download',
    onClick: async (event, { injector }) => {
      injector
        .get(ModalService)
        .fromComponent(MarketingPreferencesDownloadDialogComponent, {
          closable: true,
        })
        .subscribe();
    },
    requiresPermission: 'MarketingPreferences',
  }),
];
